/* unplugin-vue-components disabled */import script from "./Avatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Avatar.vue?vue&type=script&lang=ts&setup=true"

import "./Avatar.vue?vue&type=style&index=0&id=7950da92&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7950da92"]])

export default __exports__